import ApiTaskTypes from "../../../gd/api/task-types"
import Task from "../../../model2/task/task"
import SaveAsTemplateModel from "../save-as-template-model"

/**
 * Creates the task type the "Create new" option of the Save as template modal asks for, with the
 * content of the task already in its template. The type inherits the workflow, the included /
 * mandatory system fields and the mandatory custom fields of the type selected before "Create new".
 */
export default async function createTaskType(model: SaveAsTemplateModel, task: Task): Promise<ID> {

    const response = await ApiTaskTypes.newTaskTypeFromTemplate(buildParams(model, task)).promise()

    return _.get(response, 'taskTypeId')
}

function buildParams(model: SaveAsTemplateModel, task: Task) {

    const params: any = {
        name                : model.name,
        icon                : model.icon,
        isDefault           : model.isDefault,
        sourceTaskTypeId    : model.sourceTaskTypeId
    }

    // A source task with nothing ticked is a 400, so the task goes only with something to copy
    if (!_.isEmpty(model.selectedFields) || !_.isEmpty(model.selectedCustomFieldIds)) {
        params.taskId           = task.id
        params.fields           = model.selectedFields
        params.customFieldIds   = model.selectedCustomFieldIds
    }

    return params
}
